import { useEffect, useMemo, useRef, useState } from 'react';

import {
  createPlugins,

  // Marks
  createBoldPlugin, // bold mark
  createItalicPlugin, // italic mark
  createUnderlinePlugin, // underline mark
} from '@udecode/plate';

import components from 'components/text_editor_new/plugins/components';
import createAITextCompletion from 'components/text_editor_new/plugins/ai/ai_text_completion';
import { createAnswersPlugin } from '../plugins/answers';
import createCapitalizeFirstWordPlugin from 'components/text_editor_new/plugins/capitalize_first_word';
import createCapitalizeIPlugin from 'components/text_editor_new/plugins/capitalize_i';
import createInsertTextAfterInline from '../plugins/insert_text_after_inline';
import createParagraphPlugin from '../plugins/paragraph';
import createPlaceholders from '../plugins/placeholders';
import createSaveOnBlur from '../plugins/save_on_blur';
import { useCreateVariablesPlugin, useUpdateVariables } from '../plugins/variables';
import useEditorWithDecorators from './use_editor_with_decorators';

export default function useRichTextEditorPlugins({ composerRef }, editorProps, extraPlugins) {
  const { name, onBlur, editorId } = editorProps;

  const createVariablesPlugin = useCreateVariablesPlugin();

  const plugins = useMemo(() => {
    let pluginList = [
      // This plugin must come first
      createInsertTextAfterInline(),

      // Autocapitalization
      createCapitalizeIPlugin(),
      createCapitalizeFirstWordPlugin(),

      createAITextCompletion(),

      // general
      createSaveOnBlur(onBlur),

      // marks
      createBoldPlugin(),
      createItalicPlugin(),
      createUnderlinePlugin(),

      // elements
      createParagraphPlugin(),

      // inlines
      createPlaceholders(),

      // etc.
      createAnswersPlugin(),
      createVariablesPlugin(),
    ];

    if (extraPlugins) {
      pluginList = [...pluginList, ...extraPlugins];
    }

    return createPlugins(pluginList, { components });
  }, [extraPlugins, onBlur]);

  const editor = useEditorWithDecorators(plugins, { editorId });

  useUpdateVariables(editor);

  const editorRef = useRef(editor);
  const [, rerender] = useState(null);

  useEffect(() => {
    if (!editorRef.current) {
      editorRef.current = editor;
      rerender({});
    }
    if (!composerRef.current.editorRefs[name]) {
      composerRef.current.editorRefs[name] = editorRef;
      rerender({});
    }
  }, [editor]);
  editorProps.editorRef = editorRef;

  return editorRef;
}
